<template>
  <div>
    <h3>{{ header }}</h3>
    <p>{{ message }}</p>
    <div class="warning"><img src="/img/warning.png" alt="warning" /></div>
    <div class="buttons is-centered">
      <button class="button is-dark" @click="cancel">Cancel</button>
      <button class="button is-primary" @click="confirm">
        {{ cta }}
      </button>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "Confirm",
  data() {
    return {};
  },
  props: {
    header: String,
    message: String,
    cta: String
  },
  methods: {
    cancel() {
      store.dispatch("confirm", false);
      this.$emit("canceled");
    },
    confirm() {
      console.log("comfirmed");
      store.dispatch("confirm", true);
      this.$emit("canceled");
    }
  }
};
</script>

<style lang="scss">
h3 {
  text-align: center;
}
.warning {
  text-align: center;
  padding: 25px 0;
}
</style>
